import { useNavigate } from 'react-router-dom';
import { useKeycloak } from '@studio-toolkit/keycloak';
import { useQueryClient } from '@tanstack/react-query';
import type { ITokenApiResponse } from './apiCalls/useFetchToken';

export const useTokenAndHeaders = () => {
  const { authenticated } = useKeycloak();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const tokenData = queryClient.getQueryData<ITokenApiResponse>(['fetchToken']);

  if (!authenticated) {
    navigate('/unauthorized');
  }

  if (!tokenData || !tokenData.token) {
    throw new Error('Token not available');
  }

  return {
    headers: {
      Authorization: `Bearer ${tokenData.token}`,
      'Content-Type': 'application/json',
    },
  };
};
